module.exports = __webpack_public_path__ + "media/images/user/favicons/site-tile-150x150-a78e63f4720dfa6c21740f93ef417c0c.png";